// extracted by mini-css-extract-plugin
export default {"Swiper":"s_Swiper__E3ORw","SwiperSlide":"s_SwiperSlide__84bjp","img":"s_img__J1RAf","swiper-btn-prev":"s_swiper-btn-prev__kBR-T","swiper-btn-next":"s_swiper-btn-next__6W5CO"};